import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {RockBottom} from "../../RockBottom";
import {RockBottomParsedGameData} from "../../server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "../../server/data/RockBottomParsedInitData";
import {RockBottomSound} from "../../sound/RockBottomSound";

export class XSplitLandingController extends ReelStopPresentationController {
    private _xSplitPresent: boolean;

    constructor() {
        super("XSplitLandingController");
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        if ((RockBottom.inBonusGame)) {
            return Promise.resolve();
        }
        if (!this.isXSplitPresent(data.reelId)) {
            return Promise.resolve();
        }
        return super.onReelBounce(data);
    }

    private isXSplitPresent(reelNo: number): boolean {
        const parsedData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData();
        let parsedReels: string[][] = parsedData.reels;
        if ((reelNo !== 0) && (reelNo !== 4)) {
            for (let symId: number = 1; symId < parsedReels[reelNo].length - 1; symId++) {
                if (parsedReels[reelNo][symId] === "XS") {
                    RockBottomSound.soundPlayer.playTrack({name: RockBottomSound.XSPLIT_LANDING});
                    this._xSplitPresent = true;
                } else {
                    this._xSplitPresent = false;
                }
            }
        }
        return this._xSplitPresent;
    }
}